export const initialise = () => {

  const getCatalogue = ($stateParams, catalogueService) => {
    let options;
    if ($stateParams.catalogueVersion) {
      options = {
        catalogueVersion: $stateParams.catalogueVersion
      };
    }
    return catalogueService.getCatalogue($stateParams.catalogueId, options);
  };
  getCatalogue.$inject = ['$stateParams', 'catalogueService'];

  const getCatalogues = ($stateParams, catalogueVersionService) => {
    return catalogueVersionService.getList($stateParams.catalogueId);
  };
  getCatalogues.$inject = ['$stateParams', 'catalogueVersionService'];

  const getProduct = ($stateParams, productService) => {
    return productService.getProduct($stateParams.catalogueId, $stateParams.productId);
  };
  getProduct.$inject = ['$stateParams', 'productService'];

  angular.module('app.catalogue').config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');
    $stateProvider.state('catalogues', {
      url: '/catalogues',
      template: '<div ui-view></div>',
      parent: 'common'
    }).state('catalogues.list', {
      url: '/list',
      templateUrl: 'app/angularJS/features/catalogues/catalogue/list/catalogue_list.html',
      controller: 'CatalogueListController',
      controllerAs: 'vm'
    }).state('catalogues.create', {
      url: '/create',
      templateUrl: 'app/angularJS/features/catalogues/catalogue/create/catalogue_create.html',
      controller: 'CatalogueCreateController',
      controllerAs: 'vm'
    }).state('catalogues.copy', {
      url: '/:catalogueId/copy',
      templateUrl: 'app/angularJS/features/catalogues/catalogue/copy/catalogue_copy.html',
      controller: 'CatalogueCopyController',
      controllerAs: 'vm',
      params: {
        sourceCatalogue: undefined,
        catalogueId: undefined
      }
    }).state('catalogues.edit', {
      url: '/:catalogueId/edit',
      templateUrl: 'app/angularJS/features/catalogues/catalogue/edit/catalogue_edit.html',
      controller: 'CatalogueEditController',
      controllerAs: 'vm',
      params: {
        sourceCatalogue: undefined,
        catalogueId: undefined
      }
    }).state('catalogue', {
      url: '/catalogue/:catalogueId/:catalogueVersion',
      resolve: {
        catalogue: getCatalogue
      },
      template: '<div ui-view></div>',
      controller: 'CatalogueController',
      controllerAs: 'vm',
      parent: 'common',
      params: {
        catalogueId: undefined,
        catalogueVersion: undefined
      }
    }).state('productsCreate', {
      url: '/catalogue/:catalogueId/:catalogueVersion/products/create',
      templateUrl: 'app/angularJS/features/catalogues/product/create/product_create.html',
      controller: 'ProductCreateController',
      controllerAs: 'vm',
      params: {
        catalogueId: undefined,
        catalogueVersion: undefined
      },
      parent: 'common'
    }).state('productsCopy', {
      url: '/catalogue/:catalogueId/:catalogueVersion/products/:productId/copy',
      templateUrl: 'app/angularJS/features/catalogues/product/copy/product_copy.html',
      controller: 'ProductCopyController',
      controllerAs: 'vm',
      params: {
        sourceCatalogue: undefined,
        sourceProduct: undefined
      },
      parent: 'common'
    }).state('productsEdit', {
      url: '/catalogue/:catalogueId/:catalogueVersion/products/:productId/edit',
      templateUrl: 'app/angularJS/features/catalogues/product/edit/product_edit.html',
      controller: 'ProductEditController',
      controllerAs: 'vm',
      params: {
        catalogueId: undefined,
        catalogueVersion: undefined,
        productId: undefined,
        sourceCatalogue: undefined,
        sourceProduct: undefined
      },
      parent: 'common'
    }).state('catalogue.dashboard', {
      url: '/overview',
      templateUrl: 'app/angularJS/features/catalogues/product/catalogue_dashboard/product_catalogue_dashboard.html',
      controller: 'ProductPageController',
      controllerAs: 'vm',
      data: {
        selectedTab: 0
      }
    }).state('catalogue.product-list', {
      url: '/product-list',
      templateUrl: 'app/angularJS/features/catalogues/product/list/product_list.html',
      controller: 'ProductListController',
      controllerAs: 'vm',
      data: {
        selectedTab: 1
      }
    }).state('catalogue.catalogue_history', {
      url: '/history',
      templateUrl: 'app/angularJS/features/catalogues/catalogue/history/catalogue_history.html',
      controller: 'CatalogueHistoryController',
      controllerAs: 'vm',
      data: {
        selectedTab: 2
      }
    }).state('catalogue.catalogue_history_detail', {
      url: '/history-detail',
      templateUrl: 'app/angularJS/features/catalogues/catalogue/history/detail/catalogue_history_detail.html',
      controller: 'CatalogueHistoryDetailController',
      controllerAs: 'vm',
      params: {
        catalogueId: undefined,
        catalogueVersion: undefined,
        historyItem: undefined
      },
      data: {
        selectedTab: 2
      }
    }).state('catalogue.catalogue_versions', {
      url: '/versions',
      templateUrl: 'app/angularJS/features/catalogues/product/catalogue_versions/product_catalogue_versions.html',
      controller: 'ProductCatalogueVersionsController',
      controllerAs: 'vm',
      data: {
        selectedTab: 3
      },
      resolve: {
        catalogues: getCatalogues
      }
    }).state('catalogue.catalogue_notifications', {
      url: '/notifications',
      templateUrl: 'app/angularJS/features/catalogues/product/catalogue_notifications/product_catalogue_notifications.html',
      controller: 'ProductCatalogueNotificationsController',
      controllerAs: 'vm',
      data: {
        selectedTab: 4
      }
    }).state('variants', {
      url: '/catalogue/:catalogueId/:catalogueVersion/products/:productId/variants',
      resolve: {
        catalogue: getCatalogue,
        product: getProduct
      },
      template: '<div ui-view></div>',
      controller: 'VariantPageController',
      controllerAs: 'vm',
      parent: 'common'
    }).state('variants.list', {
      url: '/list',
      templateUrl: 'app/angularJS/features/catalogues/variant/list/variant_list.html',
      controller: 'VariantListController',
      controllerAs: 'vm',
      data: {
        selectedTab: 0
      }
    }).state('variants.product_fields', {
      url: '/fields',
      controller: 'VariantProductFieldsController',
      controllerAs: 'vm',
      templateUrl: 'app/angularJS/features/catalogues/variant/product_fields/variant_product_fields.html',
      data: {
        selectedTab: 1
      }
    }).state('variantsCreate', {
      url: '/variants/create',
      templateUrl: 'app/angularJS/features/catalogues/variant/create/variant_create.html',
      controller: 'VariantCreateController',
      controllerAs: 'vm',
      params: {
        catalogue: undefined,
        product: undefined
      },
      parent: 'common'
    }).state('variantsCopy', {
      templateUrl: 'app/angularJS/features/catalogues/variant/copy/variant_copy.html',
      controller: 'VariantCopyController',
      controllerAs: 'vm',
      params: {
        catalogueId: undefined,
        productId: undefined,
        sourceVariant: undefined
      },
      parent: 'common'
    }).state('variantsEdit', {
      templateUrl: 'app/angularJS/features/catalogues/variant/edit/variant_edit.html',
      controller: 'VariantEditController',
      controllerAs: 'vm',
      params: {
        catalogue: undefined,
        product: undefined,
        editableVariant: undefined
      },
      parent: 'common'
    }).state('variants.details', {
      templateUrl: 'app/angularJS/features/catalogues/variant/detail/variant_detail.html',
      controller: 'VariantDetailController',
      controllerAs: 'vm',
      params: {
        catalogueId: undefined,
        productId: undefined,
        variant: undefined
      }
    });
    $urlRouterProvider.otherwise('/');
  }]);
};